import axios, { AxiosInstance } from 'axios';
import { defaultRequestInterceptorFail, defaultRequestInterceptorSuccess, defaultResponseInterceptorFail, defaultResponseInterceptorSuccess } from '../axiosInterceptors';
import { dmsRequestInterceptorFail, dmsRequestInterceptorSuccess, dmsResponseInterceptorFail, dmsResponseInterceptorSuccess } from './axiosDmsInterceptors';
import { fetchAppConfig } from '../../common/configUtil';
import { IAppConfigType } from '../../models/appConfig.model';

let axiosDmsInstance: AxiosInstance = axios.create();
const initialiseAxios = async (type: IAppConfigType = IAppConfigType.PROD, reload: boolean = false) => {
  try {
    try {
      axiosDmsInstance.interceptors.request.clear();
      axiosDmsInstance.interceptors.response.clear();
    } catch {}

    axiosDmsInstance.defaults.baseURL = (await fetchAppConfig(type, reload)).ratUrl;

    // Default interceptors

    axiosDmsInstance.interceptors.request.use(defaultRequestInterceptorSuccess, defaultRequestInterceptorFail);
    axiosDmsInstance.interceptors.response.use(defaultResponseInterceptorSuccess, defaultResponseInterceptorFail);

    // Token interceptors
    axiosDmsInstance.interceptors.request.use(dmsRequestInterceptorSuccess, dmsRequestInterceptorFail);
    axiosDmsInstance.interceptors.response.use(dmsResponseInterceptorSuccess, dmsResponseInterceptorFail);
  } catch (error) {
    console.error('Error setting up axios:', error);
    throw error;
  }
};

// Initialize axiosDmsInstance asynchronously
initialiseAxios().catch((error) => {
  console.error('Error initializing axiosDmsInstance:', error);
});

export const reInitialiseDmsAxios = async (type: IAppConfigType) => {
  await initialiseAxios(type, true);
};

export default axiosDmsInstance;
